<template>
  <div class="container">
    <div class="body">
      <v-text-field
        autofocus
        filled
        background-color="textBoxBackground"
        label="Group Name"
        style="height: 66px; padding-right: 12px"
        class="mb-4"
        v-model="userEditObj.name"
        @keyup.enter="$emit('request-save')" />

      <v-textarea
        filled
        background-color="textBoxBackground"
        label="Description"
        rows="3"
        class="mb-4"
        v-model="userEditObj.description" />

      <v-list-item class="px-0">
        <v-list-item-title class="text-caption text-medium-emphasis">
          Created
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ formatDate(userEditObj.created_at) }}
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item class="px-0">
        <v-list-item-title class="text-caption text-medium-emphasis">
          Asset Count
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ userEditObj.asset_count || 0 }} assets
        </v-list-item-subtitle>
      </v-list-item>

      <v-list-item class="px-0">
        <v-list-item-title class="text-caption text-medium-emphasis">
          Group ID
        </v-list-item-title>
        <v-list-item-subtitle class="text-mono">
          {{ userEditObj.uid }}
        </v-list-item-subtitle>
      </v-list-item>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['userEditObj']);

const formatDate = (dateString) => {
  if (!dateString) return 'N/A';
  const date = new Date(dateString);
  return date.toLocaleString();
};
</script>

<style scoped>
.text-mono {
  font-family: monospace;
  font-size: 0.85em;
}
</style>
